import * as React from 'react';
import { MenuItem, Select } from '@mui/material';
import { selectorMenuProps } from './utils';
import { DEFAULT_COMPARISON, DEFAULT_COMPARISON_OPTIONS } from '../../constants';
var ComparisonSelector = function (_a) {
    var name = _a.name, _b = _a.value, value = _b === void 0 ? DEFAULT_COMPARISON : _b, _c = _a.options, options = _c === void 0 ? DEFAULT_COMPARISON_OPTIONS : _c, disabled = _a.disabled, onChange = _a.onChange;
    return (React.createElement("div", { className: "comparisonSelector" },
        React.createElement(Select, { name: name + "_operator_select", onChange: onChange, value: value, style: {}, disabled: disabled, disableUnderline: true, displayEmpty: true, MenuProps: selectorMenuProps }, options.map(function (o) { return React.createElement(MenuItem, { key: o, dense: true, value: o }, o); }))));
};
export default ComparisonSelector;
//# sourceMappingURL=ComparisonSelector.js.map